import type { FC, ReactNode } from 'react'
import React from 'react'
import styled from 'styled-components'

import { OutcomeStatus } from '@/lib/apollo/model/outcome'

type Props = {
  label: ReactNode
  outcomeStatus?: OutcomeStatus
  onSetOutcome: (outcomeStatus: OutcomeStatus) => void
  options: OptionsConfig[]
}

export interface OptionsConfig {
  status: OutcomeStatus
  label: string
  disabled?: boolean
}

const StatusDropdown = styled.select`
  padding: 10px;
  border-radius: 5px;
  text-transform: capitalize;
`

export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 10px;
  margin-bottom: 10px;
`

const OverrideOutcomeStatusFieldRowDropdown: FC<Props> = ({
  label,
  outcomeStatus,
  onSetOutcome,
  options,
}) => {
  return (
    <FieldRow>
      <div className="side-by-side-flex-start">
        {label}{' '}
        {outcomeStatus === OutcomeStatus.pass && (
          <div className="side-by-side-flex-start">
            <strong style={{ margin: '0px 5px' }}> - (Automatic Pass) </strong>
            <img src="/assets/svg/circle-tick.svg" alt="circle with a tick" />
          </div>
        )}
      </div>
      <StatusDropdown
        defaultValue={outcomeStatus}
        value={outcomeStatus as OutcomeStatus}
        disabled={outcomeStatus === OutcomeStatus.pass}
        onChange={e => onSetOutcome(e.target.value as OutcomeStatus)}
      >
        {options.map(({ label, status, disabled }, i) => (
          <option key={i} value={status} disabled={disabled ?? false}>
            {label}
          </option>
        ))}
      </StatusDropdown>
    </FieldRow>
  )
}

export default OverrideOutcomeStatusFieldRowDropdown
